var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMeetVahakPageIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 15,
    viewBox: "0 0 22 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.578 4.773c-1.087.153-2.036 1.173-2.045 1.182a.23.23 0 01-.046.037c-1.475.958-2.307.23-2.342.186-.944-.85-.078-2.276-.04-2.336a8.692 8.692 0 011.392-1.755H4.49L2.75 7.825a.21.21 0 01.05.04c2.7 3.052 6.284 5.76 7.698 6.783a.722.722 0 00.933-1.098l-1.946-1.946a.229.229 0 11.326-.323l1.035 1.036.917.917.458.47a.879.879 0 001.252-1.231l-1.786-1.863-.339-.35a.228.228 0 010-.326.23.23 0 01.326 0l2.605 2.704a.915.915 0 001.561-.612.891.891 0 00-.275-.671l-1.563-1.513-1.088-1.056a.23.23 0 11.318-.328l3.094 2.995a.863.863 0 001.391-.98.86.86 0 00-.211-.274l-5.928-5.426zM3.79.744A8.46 8.46 0 000 .006v8.988h1.4a.688.688 0 00.663-.497l2.103-6.928A.687.687 0 003.79.744z",
    fill: "#AFC4FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.32 1.188a2.152 2.152 0 00-1.55-.034c-.877.32-2.158 1.09-3.283 2.929 0 .013-.704 1.146-.041 1.755.023.02.614.516 1.76-.215.165-.172 1.198-1.208 2.42-1.32a.23.23 0 01.174.06l6.006 5.5c.028.025.053.052.078.08.688-.106 1.146-.734 1.279-.963l-2.177-5.933-4.666-1.859zM21.542 1.1a10.132 10.132 0 00-3.818.719.687.687 0 00-.371.878l2.55 6.941a.704.704 0 00.656.458H22V1.111a8 8 0 00-.458-.012z",
    fill: "#AFC4FF"
  })));
}

export default SvgMeetVahakPageIcon;